const item_en = {
  title: 'Items',
  allItems: 'All Items',
  sets: 'Sets',
  table: {
    no: 'No.',
    name: 'Name',
    minimumStock: 'Minimum Stock',
    physicalStock: 'Stock Quantity',
    groupCode: 'Group Code',
    group: 'Group',
    tag: 'Tag',
    lastChange: 'Last Change',
    assignTag: 'Assign Tag',
  },
  form: {
    title: 'Assign Tag',
    tag: 'Tag',
    tagPlaceholder: 'Select Tag',
    tagRequired: 'Tag is required',
    cancel: 'Cancel',
    assign: 'Assign',
  },
  detail: {
    title: 'Items Details',
    back: 'Back',
    name: 'Name',
    no: 'No.',
    measurementUnitID: 'Measurement Unit',
    powerConsumption: 'Power Consumption (KWH)',
    groupCode: 'Group Code',
    minimumStock: 'Minimum Stock',
    packagingFactor: 'Packaging Factor',
    unitsPerBox: 'Units Per Box',
    unitsPerPallet: 'Units Per Pallet',
    weight: 'Weight',
    width: 'Width (in mm)',
    depth: 'Depth (in mm)',
    height: 'Height (in mm)',
  },
  individual: {
    title: 'Individual Components',
  },
  customTexts: {
    name: 'Your internal designation',
    description: 'Your description',
    addTitle: 'Add internal designation',
    editTitle: 'Edit internal designation',
    namePlaceholder: 'Enter internal designation',
    descriptionPlaceholder: 'Enter description',
    save: 'Save',
    remove: 'Remove',
    saveSuccess: 'Internal designation saved',
    removeSuccess: 'Internal designation removed',
    nameRequired: 'Please enter an internal designation',
  },
  message: {
    assignSuccess: 'Sub Category assign was success',
    assignFailed: 'Sub Category assign was failed',
  },
  share: {
    action: 'Share',
    articleTitle: 'Share article',
    groupTitle: 'Share group',
    wholeOrganization: 'With the whole organization',
    specificCustomers: 'With specific customers',
    addCustomer: '+ Add customer',
    selectCustomer: 'Select customer',
    you: 'you',
    noCustomers: 'No other customers in your organization',
    customersRequired: 'Add at least one customer',
    cancel: 'Cancel',
    submit: 'Share',
    revoke: 'Revoke share',
    badge: 'shared',
    badgeCount: 'shared with {count} customer | shared with {count} customers',
    inherited: 'shared via group',
    sharedBy: 'shared by {customer}',
    shareSuccess: 'Share saved',
    revokeSuccess: 'Share revoked',
  },
  filter: {
    title: 'Filter',
    group: 'Group',
    groupPlaceholder: 'Select Group',
    subGroup: 'Sub Group',
    subGroupPlaceholder: 'Select Sub Group',
    tag: 'Tag',
    tagPlaceholder: 'Select Tag',
    category: 'Category',
    categoryPlaceholder: 'Category',
    // {0} is the selection count, substituted by PrimeVue's MultiSelect.
    categoriesSelected: '{0} categories',
    cancel: 'Cancel',
    apply: 'Apply',
  },
}

export default item_en
